import { useEffect, useLayoutEffect, useState } from "react";

function useViewPortHeight() {
	const [res, setRes] = useState({ height: window.innerHeight, width: window.innerWidth });

	useEffect(() => {
		const handleResize = () => {
			setRes({ height: window.innerHeight, width: window.innerWidth });
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useLayoutEffect(() => {
		const root = document.getElementById("root");
		const computedStyle = getComputedStyle(root);
		const sideBarCollapsedWidth = computedStyle.getPropertyValue("--sideBarCollapsedWidth")?.trim().slice(0, 2);
		const pdpMargin = computedStyle.getPropertyValue("--pdpInlineMargin")?.trim().slice(0, 2);
		const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
		const calculatedWidth = res.width - sideBarCollapsedWidth - pdpMargin * 2 - scrollBarWidth;
		const finalWidth = calculatedWidth > 1200 ? 1200 : calculatedWidth;
		root.style.setProperty("--maxContainerWidth", `${finalWidth}px`);
	}, [res.height]);

	return res;
}
export default useViewPortHeight;
